module.exports = __webpack_public_path__ + "img/744.b91e53c1.jpg";